<template>
  <div class="wrapper ">
    <side-bar :logo="empresaInfo.logoEmpresa" data-color="black" :title="empresaInfo.nomeEmpresa" class="d-print-none sidebar-webdraft">
      <mobile-menu slot="content">
        <li>
          <router-link
            v-if="this.checkLogin == true"
            :to="'/logout'"
            class="nav-link btn btn-info btn-fill text-white"
          >Logout</router-link>
        </li>
      </mobile-menu>
      
      <sidebar-link
        class="sidebar-link"
        to="/webtrack"
      >
        <i class="nc-icon nc-atom"></i>
        <p>WebTrack</p>
      </sidebar-link>

    </side-bar>
    <div class="main-panel">
      <top-navbar-site
        :checkLogin="checkLogin"
        :username="username"
        :nomeEmpresa="this.empresaInfo.nomeEmpresa"
      ></top-navbar-site>

      <dashboard-content
        @loginComplete="checkLoginStatus"
        @changeTipo="changeTipo"
        @changeContent="atualizarInfo"
        @click="toggleSidebar"
      ></dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style>

.sidebar .nav li .nav-link {
  padding-bottom: 0px;
  padding-top: 2px;
  margin-top: 0px;
  margin-bottom: 0px;
  border-radius: 0px;
}
.nav-main__links li:last-child {
  padding-bottom: 20px;
}
.sidebar .nav li > .nav-link:hover {
  background: rgb(199, 199, 199);
}
.dropdown-item {
  font-size: 12px;
}
.embarques a p {
  font-size: 12px;
}

#estatistica {
  color: #494949 !important;
}

.sidebar-webdraft p, .sidebar-webdraft i{
  color:white !important;
}
</style>
<script>
import TopNavbarSite from "./TopNavbarSite.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu.vue";
export default {
  components: {
    TopNavbarSite,
    ContentFooter,
    DashboardContent,
    MobileMenu
  },
  data() {
    return {
      categoria: "",
      tipo: "",
      baseurl: "",
      empresaInfo: {
        nomeEmpresa: "",
        logoEmpresa: ""
      },
      checkLogin: false,
      username: "Usuário",
      statusModal: null,
      statusFixo: [
        "Aguardando Embarque",
        "Saida Confirmada",
        "Em Transito",
        "Chegada Confirmada",
        "Finalizado"
      ]
    };
  },
  mounted() {
    this.setStatusModal();
    this.getInfoEmpresa();
    //console.log("TS");
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    atualizarInfo(path) {
      this.baseurl = path;
    },
    checkLoginStatus() {
      let checkLoginStatus = JSON.parse(sessionStorage.getItem("loginInfo"));

      if (checkLoginStatus != null || checkLoginStatus != undefined) {
        if (
          checkLoginStatus.hasOwnProperty("status") &&
          checkLoginStatus.status
        ) {
          this.checkLogin = true;
          this.username = checkLoginStatus.username;
        } else {
          this.checkLogin = false;
        }
      }
    },
    filtrarFixo(event) {
      let txt = event.target.name;
      if (this.baseurl.lastIndexOf("/") < 2) {
        this.$router.push({
          path: this.baseurl + "/",
          query: { filtrarFixo: txt }
        });
      } else {
        this.$router.push({ path: this.baseurl, query: { filtrarFixo: txt } });
      }
    },
    filtrarDinamico(event) {
      let txt = event.target.name;
      if (this.baseurl.lastIndexOf("/") < 2) {
        this.$router.push({
          path: this.baseurl + "/",
          query: { filtrarDinamico: txt }
        });
      } else {
        this.$router.push({
          path: this.baseurl,
          query: { filtrarDinamico: txt }
        });
      }
    },
    changeTipo(tipo) {
      this.tipo = tipo;
      this.setStatusModal();
    },
    setStatusModal() {
      this.statusModal = null;
      let menu = JSON.parse(localStorage.getItem("menu" + this.tipo));
      if (menu) {
        this.statusModal = menu;
      } else {
        var url = this.$urlApi + "/api/status-modal";
        let tipo = this.tipo;
        let args = { tipo: tipo };
        this.axios.post(url, args).then(res => {
          this.statusModal = res.data.response;
          // console.log(res.data);
          localStorage.setItem(
            "menu" + tipo,
            JSON.stringify(res.data.response)
          );
        });
      }
    },
    getInfoEmpresa() {
      let url = this.$urlApi + "/api/empresa";
      this.axios.get(url).then(res => {
        sessionStorage.setItem("empresaInfo", JSON.stringify(res.data[0]));
        this.empresaInfo.nomeEmpresa = res.data[0].NOME;
        this.empresaInfo.logoEmpresa = res.data[0].LINK;
        console.log(this.empresaInfo);
      });
    }
  }
};
</script>
